import { lazy } from "react";
import Home from "./pages/Home";
import createAppRoutes from "./createAppRoutes";

// Keep the landing page immediate; fetch other page code only when opened.
const Solutions = lazy(() => import("./pages/Solutions"));
const Services = lazy(() => import("./pages/Services"));
const Produits = lazy(() => import("./pages/Produits"));
const Contact = lazy(() => import("./pages/Contact"));
const UnderConstruction = lazy(() => import("./pages/UnderConstruction"));
const Apropos = lazy(() => import("./pages/Apropos"));
const Carriere = lazy(() => import("./pages/Carriere"));
const DescriptionProduits = lazy(() => import("./pages/produits/DescriptionProduits"));
const Catalogues = lazy(() => import("./pages/Catalogues"));
const CataloguesV2 = lazy(() => import("./pages/CataloguesV2"));
const VisualStockPage = lazy(() => import("./components/VisualStockPage"));
const VisualImmoPage = lazy(() => import("./components/VisualImmoPage"));
const ServiceDetail = lazy(() => import("./pages/services/ServiceDetail"));
const ProductDetailPage = lazy(() => import("./pages/produits/ProductDetailPage"));
const SolutionDetailPage = lazy(() => import("./pages/solutions/SolutionDetailPage"));

export default createAppRoutes({ Home, Solutions, Services, Produits, Contact, UnderConstruction, Apropos, Carriere, DescriptionProduits, NotFound: UnderConstruction, Catalogues, CataloguesV2, VisualStockPage, VisualImmoPage, ServiceDetail, ProductDetailPage, SolutionDetailPage });
